<template lang="pug">
  button(
    class="templates-card"
    @click="toggleCard"
  )
    div(
      class="templates-card__thumbnail"
      :class="{ selected: isSelected }"
    )
      e-svg-icon(
        name="eye"
        size="lg"
        @click.stop="openDialog(item.id)"
        class="templates-card__icon"
      )
      v-checkbox(
        v-if="isSelected"
        :input-value="true"
        color="#8F257D"
        background-color="#fff"
        readonly
        class="templates-card__checkbox"
        hide-details
        :ripple="false"
      )
      v-img(
        v-if="item.thumbnailUrl"
        :src="item.thumbnailUrl"
        :max-width="128"
        max-height="100%"
        class="templates-card__image"
      )
    div(class="templates-card__content")
      div(
        class="text-14px dark templates-card__text"
        :title="title"
      ) {{ title }}
</template>

<script>
import contentDialogContentTop from '~/mixins/dialogs/contentDialogContentTop'

export default {
  name: 'BlockTemplatesCard',
  mixins: [contentDialogContentTop],
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    selectedId: {
      type: String,
      default: null
    }
  },
  computed: {
    title() {
      return this._.get(this.item, 'title', '')
    },
    isSelected() {
      return this.item.id === this.selectedId
    }
  },
  methods: {
    toggleCard() {
      if (this.isSelected) {
        this.$emit('select', null)
      } else {
        this.$emit('select', this.item.id)
      }
    },
    async openDialog(id) {
      await this.contentDialogContentTop.open({
        width: '850px',
        component: 'block-templates-gallery-view',
        componentProps: {
          templateId: id
        }
      })
    }
  }
}
</script>

<style lang="scss">
.templates-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  height: 210px;
  border-radius: 4px;

  &__thumbnail {
    width: 100%;
    max-height: 160px;
    height: 100%;

    position: relative;

    border-radius: 4px;
    border: 1px solid $border-secondary;
    background: $background-primary;

    &.selected {
      border-color: $primary;
    }
  }

  &__checkbox {
    position: absolute;
    top: 8px;
    left: 8px;
    z-index: map-get($zIndexes, 'base');

    margin-top: 0 !important;
    padding-top: 0 !important;

    .v-input--selection-controls__input {
      margin-right: 0 !important;
    }
  }

  &__image {
    border-radius: 4px;
  }

  &__content {
    width: 100%;
    height: 50px;
  }

  &__text {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  &__icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(0.7);
    opacity: 0;
    transition:
      opacity 0.3s ease,
      transform 0.3s ease;
    z-index: map-get($zIndexes, 'base');
  }

  &:hover {
    .templates-card__icon {
      opacity: 1;
      transform: translate(-50%, -50%) scale(1);
      pointer-events: auto;
    }
  }
}
</style>
